import React from 'react';

function ClientsBenefitsIcon7() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="32"
      fill="none"
      viewBox="0 0 42 32"
    >
      <path
        fill="#1B1F2C"
        fillRule="evenodd"
        d="M28.288.58c-.422.421-.708 2.285-.708 4.616v3.908h-3.908c-2.274 0-4.197.288-4.598.69-.401.4-.69 2.323-.69 4.597v3.908h-3.908c-2.273 0-4.196.288-4.597.69-.4.4-.69 2.318-.69 4.572v3.883l-4.106.168c-3.163.13-4.252.4-4.738 1.175-.46.732-.46 1.28 0 2.012.52.824 1.64 1.035 6.234 1.17 3.635.108 5.883-.068 6.404-.5.546-.453.804-1.937.804-4.62v-3.953h3.908c2.273 0 4.196-.288 4.598-.69.4-.4.69-2.323.69-4.597v-3.908h3.907c2.274 0 4.197-.288 4.598-.69.4-.4.69-2.318.69-4.572V4.556l4.106-.169c3.163-.13 4.251-.4 4.738-1.174.46-.732.46-1.28 0-2.012C40.5.374 39.379.167 34.692.034c-3.939-.113-5.914.055-6.404.546z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default ClientsBenefitsIcon7;
